import Box from '@mui/material/Box'

import Typography from '@mui/material/Typography'

import type { IProviderSurveyHistoryItem } from '@brushfire/types'

import { RiCalendarEventLine, RiMoneyDollarCircleLine } from '@/shared/icons/remix'

import surveyIcon from '../assets/history-survey-icon.svg'

import { formatCompletionDate } from '../lib/format-completion-date'

import {

  historyCardBodySx,

  historyCardDateRowSx,

  historyCardSx,

  historyCardTitleSx,

  historyEarnPillSx,

  historyEarnTextSx,

  historyIconTileSx,

  historyNoRewardPillSx,

  historyNoRewardTextSx,

  historySurveyIconSx,

} from '../styles/historyStyles'



interface Props {

  item: IProviderSurveyHistoryItem

}



function formatEarnedLabel(rewardDisplay: string | null, rewardAmount: number): string {

  if (rewardDisplay?.trim()) {

    const raw = rewardDisplay.trim()

    const amountPart = raw.startsWith('$') ? raw.slice(1).trim() : raw

    return `$${amountPart} Earned`

  }

  return `$${rewardAmount.toFixed(2)} Earned`

}



export function SurveyHistoryCard({ item }: Readonly<Props>) {

  const completedLabel = formatCompletionDate(item.completedAt)



  return (

    <Box

      sx={historyCardSx}

      data-testid={`history-survey-card-${item.responseId}`}

      aria-label={`${item.name}, completed ${completedLabel}`}

    >

      <Box sx={historyIconTileSx} aria-hidden>

        <Box component="img" src={surveyIcon} alt="" sx={historySurveyIconSx} />

      </Box>



      <Box sx={historyCardBodySx}>

        <Typography component="h3" sx={historyCardTitleSx}>

          {item.name}

        </Typography>

        <Box sx={historyCardDateRowSx}>

          <RiCalendarEventLine size={13} aria-hidden />

          <span data-testid={`history-survey-card-${item.responseId}-date`}>{completedLabel}</span>

        </Box>

      </Box>



      {item.rewardEnabled ? (

        <Box sx={historyEarnPillSx} data-testid={`history-survey-card-${item.responseId}-earned`}>

          <RiMoneyDollarCircleLine size={17} color="#0e8a5f" aria-hidden />

          <Typography component="span" sx={historyEarnTextSx}>

            {formatEarnedLabel(item.rewardDisplay, item.rewardAmount)}

          </Typography>

        </Box>

      ) : (

        <Box sx={historyNoRewardPillSx} data-testid={`history-survey-card-${item.responseId}-no-reward`}>

          <RiMoneyDollarCircleLine size={17} color="#94a3b8" aria-hidden />

          <Typography component="span" sx={historyNoRewardTextSx}>

            No Reward

          </Typography>

        </Box>

      )}

    </Box>

  )

}

